import React, { FC } from 'react';

import { Settings } from '../../interfaces/Stylesheet';
import style from './PreHeader.module.scss';

interface PreHeaderProps {
  settings: Settings;
}

const PreHeaderComponent: FC<PreHeaderProps> = ({ settings }: PreHeaderProps) => {
  return (
    <div className={style.ticketHeader}>
      <div className={style.preheader}>
        {!!settings.logoUrl && (
          <img
            src={settings.logoUrl}
            className={style.ticketHeaderItem}
            alt={settings.partnerName + ' logo'}
          />
        )}
        <div className={style.ticketHeaderRightCol}>
          {!!settings.showGuidionLogo && (
            <img
              src="https://cdn.guidion.com/guidion-branding/logo-medium.png"
              alt="Guidion logo"
              className={style.ticketHeaderItem}
            />
          )}
          {/*
          Can be put back once the questionnare bug is fixed
          <LanguageSelector
            className={style.ticketHeaderItem}
            placement="header-desktop"
          />
          */}
        </div>
      </div>
    </div>
  );
};

export const PreHeader = React.memo(PreHeaderComponent);
